module.exports = __webpack_public_path__ + "img/splash.c969bbb2.png";